module.exports = __webpack_public_path__ + "static/m3-min-3812a020e79c89ad884105596d3ddf5f.png";